// NOTE: Palette is available here: https://www.figma.com/design/1ij6KlCz6pD1MXEODq8Vmr/ADS-v2---Design-system?node-id=5-460&t=YcTaHIM39RtRaEpw-0
export const Colors = {
  // base
  White: '#FFFFFF',
  Black: '#000000',
  Transparent: 'transparent',

  // primary
  BrandPink: '#EF145D',
  BrandPinkDark: '#D91254',
  // BrandPinkMiddle: '#E87198',
  // BrandPinkLight: '#F0A0BB',
  // BrandPinkLightest: '#F7D0DD',

  BrandBlue: '#483389',
  BrandBlueDark: '#5137A1',
  BrandBlueMiddle: '#6C4FC2',
  BrandBlueLighter: '#9E8AD9',
  BrandBlueLight: '#CFC5F0',
  BrandBlueLightest: '#E8E1FC',
  BrandBlueTheLightest: '#F8F5FF',

  // secondary
  Darkest: '#19122E',
  DarkestMiddle: '#251E39',
  DarkerText: '#312A44',
  DarkerMiddle: '#3C354F',
  Dark: '#534D65',
  GreyDarkest: '#68617B',
  GreyDarker: '#9590A5',
  GreyDarkerMiddle: '#B8B3C6',
  Grey: '#CDC7DB',
  GreyLighter: '#DBD7E8',
  GreyLightest: '#EBE9F5',
  Light: '#EFEDF2',
  Lighter: '#F4F3F7',
  Lightest: '#F9F9FB',
  TheLightest: '#FDFCFE',

  // green
  GreenDark: '#0D7C69',
  GreenMiddle: '#30C891',
  GreenLight: '#98E3C8',
  GreenLightest: '#E5F8F1',

  // orange
  OrangeDarkest: '#EE7F00',
  OrangeDark: '#ED9024',
  OrangeMiddle: '#FFAB48',
  OrangeLight: '#FFD5A4',
  OrangeLightest: '#FFF4E8',

  // yellow
  YellowDark: '#FAC421',
  YellowMiddle: '#FEDB50',
  YellowLight: '#FEE996',
  YellowLightest: '#FFF8DC',

  // red
  RedDark: '#EB3D3D',
  RedMiddle: '#FF5C5C',
  RedLight: '#FF9D9D',
  RedLightest: '#FFE8E8',

  // blue
  BlueDark: '#6A79FF',
  BlueMiddle: '#85AEFF',
  BlueLight: '#B6CEFF',
  BlueLightest: '#E7EFFF',

  // aqua
  AquaDark: '#00D4D4',
  AquaMiddle: '#4AF7F7',

  // violet
  VioletDark: '#9550D8',
  VioletMiddle: '#B580F8',
  VioletMiddleLighter: '#9E8AD9',
  VioletLight: '#D3B3FB',
  VioletLightest: '#F0E6FE',

  // pink
  PinkDark: '#F9599A',
  PinkMiddle: '#FF95C8',
  PinkLight: '#FFBFDE',
  PinkLightest: '#FFE3EC',

  // plum
  PlumMiddle: '#AC3ACF',

  // grass
  GrassMiddle: '#3BCF64',

  // fuchsia
  FuchsiaMiddle: '#FF35DF',

  GraphiteLight: '#B4B5B6',
  GraphiteMiddle: '#35363A',
  GraphiteDark: '#1F2124',
} as const;
